import api from './api.service';
import type { RejectionPayload } from './rejection.service';

function unwrap<T>(res: unknown): T {
  const data = (res as any)?.data ?? res;
  return (data?.data ?? data) as T;
}

/** CRM estimations (`/crm/estimations`) — universal approval helpers. */
export const crmEstimationService = {
  async submitForUniversalApproval(id: string): Promise<unknown> {
    const res = await api.post(`/crm/estimations/${id}/submit-for-universal-approval`, {});
    return unwrap(res);
  },

  async approve(id: string, remarks?: string): Promise<unknown> {
    const res = await api.post(`/crm/estimations/${id}/approve`, { remarks });
    return unwrap(res);
  },

  async rejectUniversalWorkflow(id: string, payload: RejectionPayload): Promise<unknown> {
    const res = await api.post(`/crm/estimations/${id}/reject-universal-approval`, payload);
    return unwrap(res);
  },
};
